/** Moroccan dirham amounts — French-style decimals (e.g. 1 234,56) */
export function formatPriceAmount(
  value: number | string | null | undefined
): string {
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n)) return "0,00";
  return new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}
